
import React, { useState, useRef } from "react";
import Slider from "react-slick";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Dialog, DialogContent, Grid, IconButton, Button, Box } from "@mui/material";

const images = [
    "https://picsum.photos/id/1011/800/500",
    "https://picsum.photos/id/1012/800/500",
    "https://picsum.photos/id/1013/800/500",
    "https://picsum.photos/id/1015/800/500",
    "https://picsum.photos/id/1016/800/500"
];


const chipList = [
    "2BHK",
    "2.5BHK",
    "3BHK",
    "3.5BHK"
];

function PropertyDetailsNew() {
    const [open, setOpen] = useState(false);

    const sliderSettings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };



    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);


    const totalImages = images.length;

    const mainSettings = {
        asNavFor: nav2,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (_, next) => setActiveIndex(next)
    };

    const thumbSettings = {
        asNavFor: nav1,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        swipeToSlide: true,
        infinite: true,
        arrows: false
    };
    const [selected, setSelected] = useState([]);

    const toggleChip = (chip) => {
        setSelected((prev) =>
            prev.includes(chip)
                ? prev.filter((c) => c !== chip)
                : [...prev, chip]
        );
    };

    return (

        <>
            <Header />
            <div className="content-wrapper bg-seashell">

                <section className="property-details-wrap ptb-50">
                    <div className="container">
                        <div className="row gx-5">
                            <div className="col-xl-8">
                                <div className="property-details">
                                    <div className="card mb-30">

                                        <Box position="relative">
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: 12,
                                                    right: 12,
                                                    zIndex: 2,
                                                    background: "rgba(0,0,0,0.6)",
                                                    color: "#fff",
                                                    padding: "4px 10px",
                                                    borderRadius: "12px",
                                                    fontSize: 14
                                                }}
                                            >
                                                {activeIndex + 1} / {totalImages}
                                            </Box>

                                            <Slider {...sliderSettings}>
                                                {images.map((img, index) => (
                                                    <div key={index}>
                                                        <img
                                                            src={img}
                                                            alt={`slide-${index}`}
                                                            style={{
                                                                width: "100%",
                                                                height: "280px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px"
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </Slider>

                                            {/* View All Button */}
                                            <div style={{ textAlign: "right", marginTop: -50 }}>
                                                <Button variant="outlined" onClick={() => setOpen(true)} className="vallimages">
                                                    View All Images
                                                </Button>
                                            </div>
                                        </Box>

                                    </div>
                                    <div className="card pd-20 mb-30">
                                        <div class="property-title">
                                            <h2>Prestige Lakeside Habitat</h2>
                                            <p>Prestige Group</p>
                                            <ul class="property-metainfo list-style">
                                                <li><i class="flaticon-location"></i>Varthur, Whitefield Road, Bangalore
                                                </li>

                                            </ul>
                                            <div className="chipps">
                                                <span className="property-condo">Ready to Move</span>
                                                <span className="property-status">Rera Verified</span>
                                            </div>

                                            <span>Unit Options</span>
                                            <div className="chips-container">
                                                {chipList.map((chip) => (
                                                    <button
                                                        key={chip}
                                                        className={`chip ${selected.includes(chip) ? "active" : ""}`}
                                                        onClick={() => toggleChip(chip)}
                                                    >
                                                        {chip}
                                                    </button>
                                                ))}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="card pd-20 mb-30">
                                        <h5>Pricing & Area</h5>
                                        <div class="property-desc">

                                            <ul class="property-features list-style">
                                                <li><span>Price Range</span> ₹85 L - ₹1.2 Cr</li>
                                                <li><span>Carpet Area</span> 950 - 1,200 sq.ft
                                                </li>
                                                <li><span>Avg. Price</span> ₹8,500/sq.ft</li>
                                            </ul>
                                            <p>Configuration: 2, 2.5, 3, 3.5 BHK</p>
                                            <small>*Price excludes stamp duty & registration</small>
                                        </div>


                                    </div>

                                    <div className="card pd-20 mb-30">
                                        <h5>Quick Facts</h5>
                                        <div class="property-desc">


                                            <ul class="property-features list-style facts">
                                                <li className="bg-seashell pd-20">
                                                    <small><i className="flaticon-square" ></i>Project Area</small>
                                                    12 Acres
                                                </li>
                                                <li className="bg-seashell pd-20">
                                                    <small><i className="ri-scales-2-line" ></i>Sizes</small>
                                                    950 - 1,950 sq.ft
                                                </li>

                                                <li className="bg-seashell pd-20">
                                                    <small><i className="ri-building-3-line" ></i>Project Size
                                                    </small>
                                                    8 towers • 856 units
                                                </li>
                                                <li className="bg-seashell pd-20">
                                                    <small><i className="ri-calendar-2-line" ></i>Launch Date
                                                    </small>
                                                    Jan 2019
                                                </li>

                                                <li className="bg-seashell pd-20">
                                                    <small><i className="ri-money-rupee-circle-line" ></i>Avg Price</small>
                                                    ₹9,200/sq.ft
                                                </li>
                                                <li className="bg-seashell pd-20">
                                                    <small><i className="ri-folder-keyhole-line" ></i>Possession
                                                    </small>
                                                    Ready to Move
                                                </li>
                                                <li className="bg-seashell pd-20">
                                                    <small><i className="ri-shield-check-line" ></i>RERA ID</small>
                                                    <a href="#">PRM/KA/RERA/1251/446/PR/171016/000537</a>
                                                </li>
                                            </ul>

                                        </div>


                                    </div>


                                    <div className="card pd-20 mb-30">
                                        <h5>Floor Plans</h5>
                                        <div class="property-desc bg-seashell pd-20" style={{ borderRadius: 6 }}>

                                            <ul class="property-features list-style mb-0">
                                                <li><div>
                                                    2BHK
                                                    <small>2 Bed • 2 Bath</small>
                                                </div>
                                                    <div>₹85 L
                                                        <small>Starting Price</small>
                                                    </div></li>

                                            </ul>
                                            <div className="carpetblock">
                                                <div className="carpet">
                                                    <img src="../assets/img/carpet.jpg" alt="Image" />
                                                </div>
                                            </div>

                                            <ul class="property-features list-style">
                                                <li>
                                                    <div style={{ width: '50%', textAlign: 'left' }}>
                                                        <small>Carpet Area</small>
                                                        1,150 sq.ft
                                                    </div>

                                                    <div style={{ width: '50%', textAlign: 'left' }}>
                                                        <small>Built-up Area</small>1,450 sq.ft
                                                    </div></li>

                                            </ul>
                                            <div className="header-btn">

                                                <button
                                                    type="button"
                                                    className="btn style3 loginbtn"
                                                    style={{ marginRight: 10, background: '#fff' }}
                                                >
                                                    Download Plan
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn style1"
                                                >
                                                    Get Quote
                                                </button>


                                            </div>

                                        </div>


                                    </div>

                                    <div className="card pd-20 mb-30">
                                        <h5>Project Overview</h5>
                                        <div class="property-desc">

                                            <p>Prestige Lakeside Habitat is a premium residential project offering luxurious living spaces with world-class amenities. Located in the heart of Varthur, it provides excellent connectivity to major IT hubs and commercial centers. The project features thoughtfully designed apartments with modern architecture and sustainable living concepts.</p>

                                        </div>


                                    </div>


                                    <div className="card pd-20 mb-30">
                                        <h5>More About Prestige Lakeside Habitat
                                        </h5>
                                        <div class="property-desc">

                                            <p>Prestige Lakeside Habitat stands as a testament to luxury and comfort, offering residents an unparalleled living experience. The project spans across 12 acres of beautifully landscaped gardens and features 8 towers with 856 thoughtfully designed units. Each apartment is crafted with premium finishes and modern amenities to ensure a lifestyle of comfort and convenience. The strategic location provides easy access to major IT corridors, educational institutions, healthcare facilities, and entertainment hubs, making it an ideal choice for modern families.

                                            </p>

                                        </div>


                                    </div>


                                    <div className="card pd-20 mb-30 amenities">
                                        <h5>Amenities
                                        </h5>
                                        <div class="property-desc">

                                            <div className="row d-flex df">
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            <i className="ri-water-flash-line" />
                                                        </div>
                                                        <p>Swimming Pool</p>
                                                    </div>
                                                </div>
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            < i class="ri-boxing-line"></i>

                                                        </div>

                                                        <p>Gym & Fitness
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            <i class="ri-community-line"></i>
                                                        </div>

                                                        <p>Clubhouse</p>
                                                    </div>
                                                </div>
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            <i class="ri-gamepad-line"></i>
                                                        </div>

                                                        <p>Children Play Area</p>
                                                    </div>
                                                </div>
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            <i class="ri-plant-line"></i>
                                                        </div>
                                                        <p>Landscaped Gardens</p>
                                                    </div>
                                                </div>
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            <i class="ri-shield-check-line"></i>
                                                        </div>
                                                        <p>Security</p>
                                                    </div>
                                                </div>
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            <i class="ri-flashlight-line"></i>
                                                        </div>
                                                        <p>Power Backup</p>
                                                    </div>
                                                </div>{" "}
                                                <div className="property-card style3">
                                                    <div className="property-info">
                                                        <div className="icons">
                                                            <i class="ri-parking-box-line"></i>
                                                        </div>
                                                        <p>Parking</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                    </div>

                                    <div className="card pd-20 mb-30 amenities">
                                        <h5>Location</h5>
                                        <div class="property-desc">
                                            <div className="map">
                                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3500.898559257797!2d77.1826719742949!3d28.662755882709693!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0286fa2cb1b9%3A0x65a1c9d3664253c4!2sDelhi%20Sarai%20Rohilla!5e0!3m2!1sen!2sin!4v1767617111212!5m2!1sen!2sin" width="100%" height="250px" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                            </div>
                                            <p>Nearby Places</p>

                                            <div class="property-desc">

                                                <ul class="property-features list-style lst">
                                                    <li><span className="d-flex"><div className="grey"><i class="ri-train-line"></i></div> Whitefield Railway Station</span> <span>2.5 km                       <small>8 min</small>
                                                    </span></li>

                                                    <li><span className="d-flex"><div className="grey"><i class="ri-train-line"></i></div> Phoenix MarketCity</span> <span>3.5 km
                                                        <small>12 min</small>
                                                    </span></li>

                                                    <li><span className="d-flex"><div className="grey"><i class="ri-train-line"></i></div>Columbia Asia Hospital</span> <span>1.5 km
                                                        <small>6 min</small>
                                                    </span></li>

                                                    <li><span className="d-flex"><div className="grey"><i class="ri-train-line"></i></div> Ryan International School</span> <span>2.1 km <small>7 min</small>
                                                        </span></li>

                                                    <li><span className="d-flex"><div className="grey"><i class="ri-train-line"></i></div> Whitefield Railway Station</span> <span>2.5 km<small>8 min</small>
                                                    </span></li>

                                                    <li><span className="d-flex"><div className="grey"><i class="ri-train-line"></i></div> Varthur Lake
                                                    </span> <span>1.2 km <small>4 min</small>
                                                        </span></li>

                                                </ul>

                                            </div>




                                        </div>


                                    </div>



                                    <div className="card pd-20 mb-30 amenities">

                                            <div class="property-desc mb-0">

                                                <ul class="property-features list-style lst mb-0">
                                                    <li className="reraa"><span className="d-flex"><div className="grey ico"><i class="ri-shield-check-line"></i></div> <h5>RERA Information<small className="d-block">ID: PRM/KA/RERA/1251/446/PR/171016/000537

                                                    </small></h5></span> <span className="rera-details">
                                                        <span className="property-status">Check Rera Status</span>
                                                  
                                                        </span></li>


                                                </ul>

                                            </div>




                                    </div>




                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="property-details">
                                 <div className="card pd-20 mb-30">
                                        <div class="property-title mb-0">
                                            <h5>Contact Developer</h5>
                                            <span>Developer</span>
                                            <p>Prestige Group</p>
                                          
                                            <div className="header-btn d-block dev">

                                              
                                                <button type="button" className="btn style1" >
                                                  <i class="ri-phone-line"></i>  Call Now
                                                </button>

                                                <button type="button" className="btn style3 loginbtn">  Get Callback </button>
                                            </div>

                                        </div>
                                    </div>

                                      <div className="card pd-20 mb-30">
                                        <h5>Price Summary</h5>
                                        <div class="property-desc">

                                            <ul class="property-features list-style">
                                                <li><span>Unit Type
</span> <span>2BHK</span></li>
                                                
                                                <li><span>Price Range</span> <span>₹85 L - ₹1.2 Cr</span> </li>
                                                <li><span>Carpet Area</span> <span>950 - 1,200 sq.ft</span> </li>
                                            </ul>
                                            <ul class="property-features list-style lst mb-0 pd-0" style={{paddingBottom:0}}>
                                               
                                                <li><span>Avg. Price/sq.ft</span> <span className="prce">₹8,500
</span> </li>
                                            </ul>
                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>


            {/* Gallery Dialog */}
            <Dialog
                open={open} onClose={() => setOpen(false)}
                fullWidth
                maxWidth="md"
            >
                <IconButton
                    onClick={() => setOpen(false)}
                    style={{ position: "absolute", right: 8, top: -3, zIndex: 9999 }}
                >
                    x
                </IconButton>

                <DialogContent style={{ padding: 0, overflowY: 'clip' }}>
                    <Box position="relative">
                        <Box
                            sx={{
                                position: "absolute",
                                top: 12,
                                right: 12,
                                zIndex: 2,
                                background: "rgba(0,0,0,0.6)",
                                color: "#fff",
                                padding: "4px 10px",
                                borderRadius: "12px",
                                fontSize: 14
                            }}
                        >
                            {activeIndex + 1} / {totalImages}
                        </Box>


                        {/* Main Slider */}
                        <Slider {...mainSettings} ref={(s) => setNav1(s)}>
                            {images.map((img, index) => (
                                <Box key={index}>
                                    <img
                                        src={img}
                                        alt=""
                                        style={{
                                            width: "100%",
                                            height: 400,
                                            objectFit: "cover",
                                            borderRadius: 0
                                        }}
                                    />
                                </Box>
                            ))}
                        </Slider>

                        {/* Thumbnail Slider */}
                        <Box mt={2}>
                            <Slider {...thumbSettings} ref={(s) => setNav2(s)}>
                                {images.map((img, index) => (
                                    <Box key={index} px={0.5}>
                                        <img
                                            src={img}
                                            alt=""
                                            style={{
                                                width: "100%",
                                                height: 80,
                                                objectFit: "cover",
                                                borderRadius: 0,
                                                cursor: "pointer",
                                                border:
                                                    activeIndex === index
                                                        ? "2px solid #1976d2"
                                                        : "2px solid transparent"
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Slider>
                        </Box>


                    </Box>
                </DialogContent>
            </Dialog>


            <Footer />
        </>
    );
}

export default PropertyDetailsNew;
